


































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Barcode from "../../components/bar-code.vue";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import AppConsts from "../../../lib/appconst";
import _ from "lodash";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import SerialListModal from "../../components/view-serials-paging.vue";
import SerialInfo from "@/store/entities/products/serial-info";
import moment from "moment";

class PageLineRequest extends PageRequest {
  keyword: string;
}

@Component({
  components: {
    "bar-code": Barcode,
    "serial-modal": SerialListModal,
  },
})
export default class ViewdeliveryNote extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "deliveryNote";
  linepageRequest: PageLineRequest = new PageLineRequest();
  deliveryNote: any = {};
  deliveryNoteLines: Array<any> = new Array<any>();
  linePageList: Array<any> = new Array<any>();
  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  serialInfo = new SerialInfo();
  deliveryNoteStatusPrefix = AppConsts.tableRef.tableDeliveryNote.prefix.status;
  validReturnDeliveryNoteStatusArr = [AppConsts.deliveryNoteStatus.finished];

  serialModalShow: boolean = false;
  get store() {
    return this.$store.state.deliveryNote;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  hasViewSORPermission() {
    return this.hasPermission(AppConsts.permissionNames.viewSalesOrderRequest);
  }
  //============line page =================
  get lineList() {
    var re = this.linePageList;
    var startIndex = (this.lineCurrentPage - 1) * this.linePageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get lineLoading() {
    return this.store.lineLoading;
  }
  get linePageSize() {
    return this.store.linePageSize;
  }
  get lineTotalCount() {
    return this.store.lineTotalCount;
  }
  get lineCurrentPage() {
    return this.store.lineCurrentPage;
  }
  refreshLinePageIndex() {
    this.$store.commit(`${this.namespace}/setLineCurrentPage`, 1);
  }
  linePageChange(page: number) {
    this.$store.commit(`${this.namespace}/setLineCurrentPage`, page);
    this.getLinePage();
  }
  linePageSizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setLinePageSize`, pagesize);
    this.getLinePage();
  }
  async searchLineData() {
    this.refreshLinePageIndex();
    await this.getLinePage();
  }
  async getLinePage() {
    var list = this.deliveryNoteLines;
    if (
      !_.isNil(this.linepageRequest.keyword) &&
      !_.isEmpty(this.linepageRequest.keyword)
    ) {
      var keyWord = this.linepageRequest.keyword.toUpperCase();
      list = _.filter(this.deliveryNoteLines, function(o) {
        return (
          o.product.sku.toUpperCase().indexOf(keyWord) >= 0 ||
          o.product.sku.toUpperCase().indexOf(keyWord) >= 0
        );
      });
    }
    this.$store.commit(
      `${this.namespace}/setLineTotalCount`,
      _.isNil(list) ? 0 : list.length
    );
    this.linePageList = Util.pagingItems(
      list,
      this.linePageSize,
      this.lineCurrentPage
    );
  }

  async returnDeliveryNote() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.ReturnDeliveryNote"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        this.$store
          .dispatch({
            type: `${this.namespace}/return`,
            data: {
              id: this.id,
            },
          })
          .then(async () => {
            Util.showSuccessMsg(this, "Success.ReturnDeliveryNote");
            this.getDeliveryNote();
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }

  //========== serials

  openSerialModal() {
    this.serialModalShow = true;
  }

  closeSerialModal() {
    this.serialModalShow = false;
    this.serialInfo = new SerialInfo();
  }
  showDetail(row) {
    this.spinShow = true;

    this.$store
      .dispatch({
        type: `${this.namespace}/getLineSerials`,
        data: {
          id: row.id,
        },
      })
      .then((result) => {
        this.serialInfo.qty = row.qty;
        this.serialInfo.productName = row.product.name;
        this.serialInfo.productId = row.productId;
        this.serialInfo.sku = row.product.sku;
        this.serialInfo.serials = _.map(result, function(item) {
          var serial = {
            serialNo: item,
          };
          return serial;
        });
        this.openSerialModal();
      })
      .finally(() => {
        this.spinShow = false;
      });
  }
  //======== functions ===========
  canReturnDeliveryNote() {
    if (
      this.validReturnDeliveryNoteStatusArr.includes(
        this.deliveryNote.statusCode
      ) &&
      this.hasPermission(AppConsts.permissionNames.returnDeliveryNote) &&
      this.isTenant()
    ) {
      return true;
    }
    return false;
  }
  cancel() {
    this.$emit("input", false);
    this.$root.$router.push({ name: "delivery-note" });
  }
  async getDeliveryNote() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/get`,
        data: { id: this.id },
      })
      .then(async (result) => {
        this.deliveryNote = result;
        this.id = this.deliveryNote.id;
        this.code = this.deliveryNote.code;
        this.deliveryNoteLines = this.deliveryNote.lines;
        this.searchLineData();
      });
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: `${this.namespace}/export`,
      data: { id: this.id },
    });
  }

  async exportMaThung()
  {
    await this.$store.dispatch({
      type: `${this.namespace}/exportMaThungOfDn`,
      data: {
        dnid:  this.id
      }
    });
  }

  async created() {
    this.spinShow = true;
    try {
      this.id = +this.$root.$router.currentRoute.params.id;
      await this.getDeliveryNote();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  get lineColumns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      {
        title: Util.L("Sku"),
        width: 150,
        key: "product.sku",
        render: (h: any, params: any) => {
          return h("span", params.row.product.sku);
        },
      },
      {
        title: Util.L("ProductName"),
        width: 250,
        key: "product.name",
        render: (h: any, params: any) => {
          return h("span", params.row.product.name);
        },
      },
      {
        title: Util.L("ModelSku"),
        width: 120,
        key: "modelSKU",
      },
      {
        title: Util.L("ExportBrandName"),
        width: 200,
        key: "exportBrandName",
      },
      {
        title: Util.L("Unit"),
        width: 100,
        key: "product.productUnit.name",
        render: (h: any, params: any) => {
          if (_.isNil(params.row.product.productUnit)) return "";
          return h("span", params.row.product.productUnit.name);
        },
      },
      {
        title: `${Util.L("ConfigPrice")}`,
        key: "configPrice",
        width: 100,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.configPrice));
        },
      },
      {
        title: Util.L("OrderType"),
        width: 100,
        key: "orderTypeId",
        render: (h: any, params: any) => {
          if (_.isNil(params.row.orderType)) return "";
          return h("span", params.row.orderType.name);
        },
      },

      {
        title: Util.L("DiscountType"),
        key: "discountType",
        width: 100,
        render: (h: any, params: any) => {
          if (_.isNil(params.row.discountType)) return "";
          return h(
            "span",
            Util.L(AppConsts.discountTypePrefix + params.row.discountType)
          );
        },
      },
      {
        title: `${Util.L("DiscountInfo")}`,
        slot: "discount",
        width: 220,
      },
      {
        title: `${Util.L("DiscountRate")}`,
        key: "discountRate",
        width: 200,
        align: "right",
        render: (h: any, params: any) => {
          if (_.isNil(params.row.discountRate) || params.row.discountRate <= 0)
            return "";
          return h("span", `${params.row.discountRate} %`);
        },
      },
      {
        title: `${Util.L("Discount")}`,
        key: "discountAmount",
        width: 100,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.discountAmount));
        },
      },
      {
        title: `${Util.L("Tax")}`,
        key: "tax",
        width: 100,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.tax));
        },
      },
      {
        title: `${Util.L("DeliveryQty")}`,
        key: "qty",
        width: 100,
        align: "right",
        slot: "qty",
      },
      {
        title: `${Util.L("Price")}`,
        key: "price",
        width: 100,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.price));
        },
      },
      {
        title: `${Util.L("TotalAmount")}`,
        key: "totalAmount",
        width: 100,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.totalAmount));
        },
      },
      {
        title: Util.L("Note"),
        width: 120,
        key: "note",
      },
    ];
  }
}
